module.exports = __webpack_public_path__ + "static/media/ab4.2bf08416.png";